export default "__VITE_ASSET__CKVAv3WC__"